import React from 'react';
import UnifiedAuth from '@/components/auth/UnifiedAuth';

export default function AuthScreen() {
  return <UnifiedAuth />;
}
